import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { any, arrayOf, bool, func, shape, string } from 'prop-types';
import { withHandlers } from 'recompose';
import withTooltip from './withTooltip';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: '100%',
    marginBottom: 0,
    marginTop: theme.spacing(1),
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
    textAlign: 'left',
    '& .MuiFilledInput-root': {
      paddingLeft: 0,
      paddingTop: 0,
      backgroundColor: '#ffffff',
    },
    '& .MuiInputLabel-filled.MuiInputLabel-shrink': {
      transform: 'translate(5px, -12px) scale(0.75)',
    },
    '& .MuiInputLabel-filled': {
      transform: 'translate(5px, 12px) scale(1)',
    },
    '& .MuiFormHelperText-contained': {
      marginLeft: 0,
    },
  },
  input: {
    width: 200,
  },
}));

function SelectComponent(props) {
  const {
    id,
    label,
    value,
    options = [],
    onChange,
    readOnly = false,
    required = false,
    error,
    ...restProps
  } = props;
  const classes = useStyles();
  const currValue = value
    ? options.filter((option) => option.value === value)[0]
    : null;

  return (
    <FormControl
      required={required}
      key={`formControl-${id}`}
      className={classes.formControl}
      error={typeof error !== 'undefined'}
    >
      <Autocomplete
        value={currValue}
        onChange={onChange}
        options={options}
        getOptionLabel={(option) => {
          return option.label;
        }}
        disabled={readOnly}
        style={{ padding: 0 }}
        renderInput={(params) => (
          <TextField
            inputProps={{
              name: label,
              id,
              readOnly,
            }}
            className={classes.selectEmpty}
            label={label}
            required={required}
            variant="filled"
            error={!!error}
            helperText={typeof error !== 'undefined' && (error || 'Required')}
            {...params}
          />
        )}
        autoHighlight
        {...restProps}
      />
    </FormControl>
  );
}

SelectComponent.propTypes = {
  id: string.isRequired,
  label: string.isRequired,
  value: any,
  options: arrayOf(
    shape({
      label: any.isRequired,
      value: any.isRequired,
    })
  ),
  onChange: func.isRequired,
  readOnly: bool,
  required: bool,
  tooltip: string,
  error: string || bool,
};

SelectComponent.defaulProps = {
  options: [],
};

const SelectWithTooltip = withTooltip(SelectComponent);
const enhance = withHandlers({
  onChange: (props) => (event, value, reason) => {
    //value always is an object {id: string, value: string, ...etc }, but we want to dispatch only "value" property to the store
    const toSend = reason === 'clear' ? null : value.value;
    props.onChange(toSend);
  },
});

export default enhance(SelectWithTooltip);



// WEBPACK FOOTER //
// ./src/view/forms/components/FormSelect.js